import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Highcharts3d from 'highcharts/highcharts-3d'
import ChartRenderFunnel from '../../component/Charts/ChartRenderFunnel'

require('highcharts/modules/funnel')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);


export default class ChartBasic extends Component {

  is3d = (chartType) => {
    return chartType && chartType.indexOf('3d') > -1    
  }
  
  isFunnel = (chartType) => {
    return chartType && chartType.indexOf('funil') > -1 || chartType.indexOf('funnel') > -1    
  }
  

  render(){
    return(<div>      
      {this.is3d(this.props.dataset.chartType)
          ?(<HighchartsReact highcharts={Highcharts3d(Highcharts)} options={this.props.report} />)
          : this.isFunnel(this.props.dataset.chartType) 
          ? (<ChartRenderFunnel dataset={this.props.dataset} />)
        :(<HighchartsReact highcharts={Highcharts} options={this.props.report} />)}
    </div>)
  }
}